export default __webpack_public_path__ + "static/media/background.3426cadd.jpg";